// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchResetAccounts,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/UserList/Handlers/CreateUser";
import assignVmiUserRoles from "@vanmeter/App/Handlers/UserSetup/AssignVmiUserRoles";

export const ResetRole: typeof PopulateApiParameter = async props => {
    props.apiParameter.account.role = "";
};

export const AssignVmiUserRoles: typeof DispatchResetAccounts = async props => {
    if (props.apiResult.successful && props.apiResult.result) {
        props.dispatch(
            assignVmiUserRoles({
                id: props.apiResult.result.id ?? "",
                approver: props.apiParameter.account.approver || "",
                Roles: (props.apiParameter.account as any)?.roles || [],
                onError: errorMessage => {
                    props.parameter.onError?.(errorMessage as string);
                },
            }),
        );
    }
};

addToChainAfter(chain, PopulateApiParameter, ResetRole);
addToChainBefore(chain, DispatchResetAccounts, AssignVmiUserRoles);
